import {BdkTabGroup} from '@breuni-ui/bdk-tabs';
import {safeDefine} from '@breuni-ui/safe-define';

// empty by intention
class EntsTabGroup extends BdkTabGroup {
}

safeDefine('ents-tab-group', EntsTabGroup);
